import type { PeekPriceSmallHotelCardData } from './accommodation';
import type {
  PeekPriceSmallBookableTransportCardData,
  PeekPriceUnbookableTransportCardData,
} from './transport';

export enum PeekPriceModalCardType {
  BookableTransport = 'bookableTransport',
  UnbookableTransport = 'unbookableTransport',
  Accommodation = 'accommodation',
}

export interface MultiIngredientAccommodationCard {
  type: PeekPriceModalCardType.Accommodation;
  data: PeekPriceSmallHotelCardData;
}

export interface MultiIngredientBookableTransportCard {
  type: PeekPriceModalCardType.BookableTransport;
  data: PeekPriceSmallBookableTransportCardData;
}

export interface MultiIngredientUnbookableTransportCard {
  type: PeekPriceModalCardType.UnbookableTransport;
  data: PeekPriceUnbookableTransportCardData;
}

export type PeekPriceMultiIngredientCard =
  | MultiIngredientAccommodationCard
  | MultiIngredientBookableTransportCard
  | MultiIngredientUnbookableTransportCard;

export function isMultiIngredientAccommodationCard(
  card: PeekPriceMultiIngredientCard
): card is MultiIngredientAccommodationCard {
  return card.type === PeekPriceModalCardType.Accommodation;
}

export function isMultiIngredientBookableTransportCard(
  card: PeekPriceMultiIngredientCard
): card is MultiIngredientBookableTransportCard {
  return card.type === PeekPriceModalCardType.BookableTransport;
}

export function isMultiIngredientUnbookableTransportCard(
  card: PeekPriceMultiIngredientCard
): card is MultiIngredientUnbookableTransportCard {
  return card.type === PeekPriceModalCardType.UnbookableTransport;
}
